// extracted by mini-css-extract-plugin
export default {"firstPage":"FirstPage_firstPage__eIAyY","description":"FirstPage_description__nvvQ4","head":"FirstPage_head__1sMTV","foot":"FirstPage_foot__LlYo2"};